<template>
  <div>
    <slot name='default'
          v-bind:bounds='bounds'
          v-bind:worldPos='worldPos'
          v-bind:updateContainerBounds='updateContainerBounds'/>
  </div>
</template>
<script>
const CONTAINER_UPDATE_CONTAINER_BOUNDS_CACHE = new WeakMap();
export default {
  props:{
    container:{
      type:Object,
      required:true
    },
    renderTools:{
      type:Object,
      required:true
    }
  },
  data() {
    const updateContainerBounds = this.getContainerUpdateBounds(this.container.container);
    return {
      updateContainerBounds,
      inBounds:{
        left:0,right:0,
        top:0,bottom:0,
        width:0,height:0
      },
      bounds:{
        p1:{x:0, y:0},
        p2:{x:0, y:0},
        p3:{x:0, y:0},
        p4:{x:0, y:0},
        width:0,height:0
      },
      worldPos:{
        x:5,
        y:5
      }
      //c:this.container,
      //c:{worldTransform:this.container.getWorldTransform()},
      //c:Object.freeze(this.container)
      //c:Object.freeze({worldTransform:this.container.worldTransform})
    }
  },
  created() {
    this.internalUpdateBounds();

  },
  mounted() {
  },
  beforeDestroy() {
    CONTAINER_UPDATE_CONTAINER_BOUNDS_CACHE.delete(this.container.container);
  },
  methods: {
    getContainerUpdateBounds(container) {
      if (CONTAINER_UPDATE_CONTAINER_BOUNDS_CACHE.has(container)) {
        return CONTAINER_UPDATE_CONTAINER_BOUNDS_CACHE.get(container);
      }
      CONTAINER_UPDATE_CONTAINER_BOUNDS_CACHE.set(container, this._updateContainerBounds.bind(this));
      return CONTAINER_UPDATE_CONTAINER_BOUNDS_CACHE.get(container);
    },
    _updateContainerBounds(clone, doOthers=true) {
      this.container.containerUpdateTransform();
      if (clone) {
        this.internalUpdateBounds();
      } else {
        //this.internalUpdateBounds();
      }

      if (doOthers) {
        const parent = this.container.getParent();
        this.doChildren(parent);
      } else {
        //this.doChildren(this.container.container);
      }
    },
    doChildren(container) {
      container.children.forEach( (child) => {
        if (CONTAINER_UPDATE_CONTAINER_BOUNDS_CACHE.has(child)) {
          CONTAINER_UPDATE_CONTAINER_BOUNDS_CACHE.get(child)(true, false);
        }
        this.doChildren(child);
      });
    },
    internalUpdateBounds() {
      const {left,top,right,bottom,width,height} = this.container.getBounds();
      this.$set(this.inBounds, 'left', left);
      this.$set(this.inBounds, 'right', right);
      this.$set(this.inBounds, 'top', top);
      this.$set(this.inBounds, 'bottom', bottom);
      this.$set(this.inBounds, 'width', width);
      this.$set(this.inBounds, 'height', height);

      const p1 = {
        x: this.inBounds.left,
        y: this.inBounds.top
      }
      const p2 = {
        x: this.inBounds.right,
        y: this.inBounds.top
      }
      const p3 = {
        x: this.inBounds.right,
        y: this.inBounds.bottom
      }
      const p4 = {
        x: this.inBounds.left,
        y: this.inBounds.bottom
      }

      this.$set(this.bounds.p1, 'x', p1.x);
      this.$set(this.bounds.p1, 'y', p1.y);

      this.$set(this.bounds.p2, 'x', p2.x);
      this.$set(this.bounds.p2, 'y', p2.y);

      this.$set(this.bounds.p3, 'x', p3.x);
      this.$set(this.bounds.p3, 'y', p3.y);

      this.$set(this.bounds.p4, 'x', p4.x);
      this.$set(this.bounds.p4, 'y', p4.y);

      this.$set(this.bounds, 'width', width);
      this.$set(this.bounds, 'height', height);

      const worldPos = this.renderTools.getWorldPosition(this.container, {x:0,y:0});
      this.worldPos.x = worldPos.x;
      this.worldPos.y = worldPos.y;

    }
  },
  computed:{
    /*
    bounds() {
      const p1 = {
        x: this.inBounds.left,
        y: this.inBounds.top
      }
      const p2 = {
        x: this.inBounds.right,
        y: this.inBounds.top
      }
      const p3 = {
        x: this.inBounds.right,
        y: this.inBounds.bottom
      }
      const p4 = {
        x: this.inBounds.left,
        y: this.inBounds.bottom
      }

      return {
        p1,
        p2,
        p3,
        p4
      }
    },
    */
  }
}
</script>
